<div class="modal-head">
  <h1 mat-dialog-title class="mb-0">{{ "VIDEO_DETAIL.SHARE" | translate }}</h1>
  <a href="javascript:void(0)" mat-button (click)="close()">
    <span class="mdi mdi-close"></span>
  </a>
</div>
<div class="col-12">
  <hr />
</div>
<div class="modal-body" mat-dialog-content>
  <div class="text-center px-4">
    <div class="mx-auto mb-3" style="width: 200px">
      <div class="ratio-slider ratio-16-9">
        <img src="{{ data.thumbnails | thumbnails: 'landscape' }}" />
      </div>
    </div>
    <figcaption class="o-flag__body pl-3">
      <h5 class="font-bold">{{ data.name }}</h5>
    </figcaption>
  </div>
  <div class="share-icons px-4 pt-4">
    <div class="icons-social">
      <share-button
        class="social-btn"
        *ngIf="
          (data?.type == 'video' || data?.type == 'live') &&
          data?.source == 'system'
        "
        [size]="10"
        button="facebook"
        url="{{ appConstant.shareUrl + 'video-detail/' + data.public_id }}"
        (click)="onBlurEvent()"
      >
      </share-button>
      <share-button
        *ngIf="
          (data?.type == 'video' || data?.type == 'live') &&
          data?.source == 'system'
        "
        [size]="10"
        button="twitter"
        url="{{ appConstant.shareUrl + 'video-detail/' + data.public_id }}"
        (click)="onBlurEvent()"
      >
      </share-button>
      <share-button
        class="facebook"
        *ngIf="data?.type == 'series' && data?.source == 'system'"
        [size]="10"
        button="facebook"
        url="{{ appConstant.shareUrl + 'series-detail/' + data.public_id }}"
        (click)="onBlurEvent()"
      >
      </share-button>
      <share-button
        *ngIf="data?.type == 'series' && data?.source == 'system'"
        [size]="10"
        button="twitter"
        url="{{ appConstant.shareUrl + 'series-detail/' + data.public_id }}"
        (click)="onBlurEvent()"
      >
      </share-button>
      <!-- <a
        *ngIf="data?.type == 'video' && data?.source == 'system'"
        href="{{ appConstant.shareUrl + 'video-detail/' + data.public_id }}"
        class="facebook"
      >
        <span class="icon-facebook"></span>
      </a>
      <a
        *ngIf="data?.type == 'series' && data?.source == 'system'"
        href="{{ appConstant.shareUrl + 'series-detail/' + data.public_id }}"
        class="facebook"
      >
        <span class="icon-facebook"></span>
      </a>
      <a
        *ngIf="data?.type == 'video' && data?.source == 'system'"
        href="{{ appConstant.shareUrl + 'video-detail/' + data.public_id }}"
        class="twitter"
      >
        <span class="mdi mdi-twitter"></span>
      </a>
      <a
        *ngIf="data?.type == 'series' && data?.source == 'system'"
        href="{{ appConstant.shareUrl + 'series-detail/' + data.public_id }}"
        class="twitter"
      >
        <span class="mdi mdi-twitter"></span>
      </a> -->
      <!-- <a href="javascript:void(0)" class="email">
          <span class="mdi mdi-email"></span>
        </a> -->
    </div>
  </div>
</div>
